import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";

@Component({
    selector: "fhm-venue-require-action-multi-select-control",
    templateUrl: "./venue-require-action-multi-select-control.component.html",
    standalone: false
})
export class VenueRequireActionMultiSelectControlComponent implements OnChanges {
    @Output() public removed: EventEmitter<any> = new EventEmitter();

    @Output() public valueChange: EventEmitter<string[]> = new EventEmitter();

    @Input() public value: string[];

    public selectedValue: any[];

    public options: any[] = [
        {label: "Contract Sign", value: "requiresContractSign"},
        {label: "Director Contract Sign", value: "requiresContractDirectorSign"},
        {label: "Direct Debit", value: "requiresBilling"},
        {label: "Payment Account (Stripe)", value: "requiresAppPaymentAccount"},
        {label: "Sales Handover", value: "requiresSalesHandover"}
    ];

    public updateStateOnValueChange(): void {
        if (this.selectedValue) {
            this.valueChange.emit(this.selectedValue.map(value => value["value"]));
        } else {
            this.valueChange.emit();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.selectedValue = [];
        this.options.forEach(d => {
            if (this.value && this.value.indexOf(d.value) >= 0) {
                this.selectedValue.push(d);
            }
        });
    }

}
